import './LastStatusInfo.scss'
import { useTranslation } from 'react-i18next'
import { Spinner } from 'react-bootstrap'
import { MachineConected } from 'aw-consts'

const LastStatusInfo = (props: { _id: number, token: string, refresh: boolean, isMachineConnected: MachineConected }) => {

    const { t } = useTranslation()

    return (
        <>
            {
                props.refresh ? <div className='text-center pt-1'><Spinner animation="border" style={{ color: 'var(--accent-color)' }}/></div> :
                    <div className={`bgprimary rounded rounded-1 d-flex align-items-center justify-content-center`} style={{ height: '50px'}}>
                        <section className='lastStatusInfoImg me-4'><i className='bi bi-activity fs-1'/></section>
                        <span className="h5 mb-1">{t('Working')}</span>
                    </div>
            }
        </>
    )
}

export default LastStatusInfo